import { useState } from "react";
import { Menu, ActionIcon } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/sharp-solid-svg-icons";
import { faClipboardList, faEye } from "@fortawesome/sharp-regular-svg-icons";
import { ProviderReferralsQuery } from "@/__generated__/graphql";
import { AppealLetterViewerModal } from "./AppealLetterViewerModal";
import styles from "./referral-actions-dropdown.module.scss";

interface ReferralActionsDropdownProps {
  appeal: ProviderReferralsQuery["referrals"]["referrals"][number]["appeal"];
  onUpdateOutcome: () => void;
  onViewError?: (error: string) => void;
  canView: boolean;
  canUpdateOutcome: boolean;
}

export function ReferralActionsDropdown({
  appeal,
  onUpdateOutcome,
  onViewError,
  canView,
  canUpdateOutcome,
}: ReferralActionsDropdownProps) {
  const [opened, setOpened] = useState(false);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const patientName = appeal.patient
    ? `${appeal.patient.firstName} ${appeal.patient.lastName}`
    : undefined;

  if (!canUpdateOutcome && !canView) {
    return null;
  }

  return (
    <>
      <Menu opened={opened} onChange={setOpened} position="bottom-end">
        <Menu.Target>
          <ActionIcon
            variant="subtle"
            color="gray"
            aria-label="Referral actions"
          >
            <FontAwesomeIcon icon={faEllipsisVertical} />
          </ActionIcon>
        </Menu.Target>

        <Menu.Dropdown className={styles.dropdown}>
          {canUpdateOutcome && (
            <Menu.Item
              onClick={onUpdateOutcome}
              className={styles.menuItem}
              leftSection={
                <FontAwesomeIcon
                  icon={faClipboardList}
                  className={styles.icon}
                />
              }
            >
              <span className={styles.underlinedText}>
                Report appeal status
              </span>
            </Menu.Item>
          )}
          {canView && (
            <Menu.Item
              onClick={() => setIsViewerOpen(true)}
              className={styles.menuItem}
              leftSection={
                <FontAwesomeIcon icon={faEye} className={styles.icon} />
              }
            >
              <span className={styles.underlinedText}>View appeal letter</span>
            </Menu.Item>
          )}
        </Menu.Dropdown>
      </Menu>

      <AppealLetterViewerModal
        opened={isViewerOpen}
        onClose={() => setIsViewerOpen(false)}
        appealId={appeal.appealId}
        patientName={patientName}
        onError={onViewError}
      />
    </>
  );
}
